import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styles from './ResultError.styles';
import { css } from 'aphrodite/no-important';
import { Buttons, ImageWrapper } from 'conversional-components';
import { MESSAGETYPES } from 'conversional-iframe-communication';
import { sendToHost } from 'conversional-iframe-communication';
import { JourneysSelectors, useAppSelector } from 'conversional-journey';
var IMAGES = {
    NOT_FOUND: 'https://conversional.de/files/filestore/file/3526/404Go.png',
};
export var closeJourney = function () {
    sendToHost.publish(MESSAGETYPES.JOURNEY_CLOSE);
};
function ResultErrorComponent(_a) {
    var text = _a.text, buttonText = _a.buttonText;
    var theme = useAppSelector(JourneysSelectors.selectTheme);
    return (_jsxs("div", { className: css(styles.errorContainer), children: [_jsx("div", { className: css(styles.image), children: _jsx(ImageWrapper, { src: IMAGES.NOT_FOUND, alt: "Image not found" }) }), _jsx("div", { className: css(styles.text), children: text }), _jsx(Buttons.Ghost, { onClick: closeJourney, customStyles: styles.button, theme: theme, children: _jsx("span", { children: buttonText }) })] }));
}
export function ResultError(_a) {
    var status = _a.status;
    switch (status) {
        //TODO: TBD Based on Design
        case 404:
            return (_jsx(ResultErrorComponent, { buttonText: 'Back to the home page', text: 'Oops! Something is wrong!' }));
    }
    return _jsx("span", { children: "Unknown Error" });
}
